import * as React from 'react';

import { DateTime } from 'luxon';

import { IApprovalListData, EventFormStatus, IReportMetadata } from '../api/clients';

const getReportViewData = (drafts: IReportMetadata[], submissions: IApprovalListData[]) => {
  const draftViewData = drafts?.map<IReportMetadata>((draft) => ({
    id: draft.id,
    status: draft.status || EventFormStatus.Draft,
    title: draft.title || '',
    subtitle: draft.subtitle || '',
    reasonDeleted: '',
  })) || [];

  const submissionViewData = submissions?.map<IReportMetadata>((submission) => ({
    id: submission.id,
    status: submission.status || EventFormStatus.Submitted,
    title: `${submission.aircraftNumber} | ${submission.eventType2}`,
    subtitle: [
      `[${submission.flightNumber}]`,
      submission.departureAirport,
      '-',
      submission.scheduledArrivalAirport,
      '|',
      DateTime.fromISO(submission.eventDate || '').toLocaleString(),
    ].join(' '),
    reasonDeleted: submission.reasonDeleted || '',
  })) || [];

  return [
    ...draftViewData,
    ...submissionViewData,
  ];
};
function useGetReportViewData(drafts: IReportMetadata[], submissions: IApprovalListData[]): IReportMetadata[] {
  const reportViewData = React.useMemo<IReportMetadata[]>(() => getReportViewData(drafts, submissions), [drafts, submissions]);
  return reportViewData;
}

export default useGetReportViewData;
